import React, { useState } from "react";
import { Grid, Typography, TextField } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import HomeIcon from '@mui/icons-material/Home';
import PollOutlinedIcon from '@mui/icons-material/PollOutlined';
import {
  useDashChartTabsDispatch,
  useDashChartTabsStore,
} from "../../contexts/single-dashboard/DashChartTabsContext";
import { useChartStore } from "../../contexts/ChartContext";
import { useTrack } from "../../analytics/hooks";
import { useDashboardStore } from "../../contexts/single-dashboard/DashboardContext";

const verticalLine = {
  position: "absolute",
  height: "56%",
  top: "25%",
  right: "2px",
  content: "''",
  borderLeft: "1px solid #E2E6E9",
  opacity: "1",
};

export default function TabComponent({
  title,
  classType,
  chartId, //optional to close the right chart in Tabs
  handleTitleChange, //optional, function to change the title on the tab
}) {
  const [showClearIcon, setShowClearIcon] = useState(false);
  const { tabs, selectedTabId } = useDashChartTabsStore();
  const dashcharttabsDispatch = useDashChartTabsDispatch();
  const { charts } = useChartStore();
  const { editedDashboard } = useDashboardStore();
  const [tabTitle, setTabTitle] = useState(title);

  const handleTextChange = (e) => {
    setTabTitle(e.target.value);
  }
  const track = useTrack();

  const indexArray = tabs.map((tab) => tab.id);
  const tabIndex = classType === "Dashboard" ? 0 : indexArray.indexOf(chartId);

  const handleBlur = () => {
    if(tabTitle === title){//if the title is not changed
      return
    }
    if(tabTitle === ""){//if the title is set to empty, then we need to update the tabTitle to original value, but not pass to endpoint to update it
      setTabTitle(title)
      return
    }
    handleTitleChange(tabTitle)
  }

  const handleCloseChart = (e) => {
    // Prevent the click event from propagating to the parent component
    e.stopPropagation();

    dashcharttabsDispatch({
      type: "deleteTab",
      payload: tabIndex,
    });

    //track the closing of the chart tab
    track("widget_edit_close", {
      chart: charts[chartId],
      dashboard: editedDashboard
    })

    dashcharttabsDispatch({
      type: "setSelectedTabId",
      payload: 0,
    });
  };

  const dashOrChartWidth = classType === "Dashboard" ? "200px" : "150px"

  return (
    <>    
      <Grid
        container
        sx={{
          height: "62%",
          width: dashOrChartWidth,
          alignItems: "center", 
        }}
        onMouseEnter={() => setShowClearIcon(true)}
        onMouseLeave={() => setShowClearIcon(false)}
      >
        <Grid
          item
          sx={{
            display: "flex",  
            alignItems: "center", 
            width: "100%",  
          }}
        >
          <Grid
            item
            sx={{
              height: "100%",
              marginRight: "6px",
              display: "flex", 
              justifyContent: "center",
              alignItems: "center",
              width: "20%",
            }}
          >
            {classType === "Dashboard" ? (
              <HomeIcon sx={{ color: "#AC5CCC", height: "20px", width: "20px" }} />
            ) : (
              <PollOutlinedIcon sx={{ color: "#AC5CCC", height: "20px", width: "20px" }} />
            )}
          </Grid>
          <Grid
            item
            sx={{
              display: "flex",  
              alignItems: "center",
              width: showClearIcon ? "75%" : "100%", 
              overflow: "hidden",
            }}
          >
            {
              selectedTabId !== tabIndex ? 
              <Typography
                sx={{
                  textTransform: "none",
                  textAlign: "left",
                  font: "normal normal 700 14px/18px Lato",
                  letterSpacing: "0px",
                  color: "#100C08",
                  opacity: "1",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  width: "100%",  
                }}
              >
                {tabTitle}
              </Typography> :
              (
                handleTitleChange ? 
                <TextField
                  value={tabTitle}
                  onChange={handleTextChange}
                  onBlur={handleBlur} // Exit edit mode when focus is lost
                  fullWidth
                  sx={{
                    "& .MuiInputBase-input": {
                      textTransform: "none",
                      textAlign: "left",
                      font: "normal normal 700 14px/18px Lato",
                      letterSpacing: "0px",
                      color: "#100C08",
                      opacity: "1",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      padding: "0px 3px", 
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        border: "none"
                      },
                      "&:hover fieldset": {
                        border: "none"
                      },
                      "&.Mui-focused fieldset": {
                        border: "1px solid var(--Tertiary-500, #00A6FF)",
                      },
                    },
                  }}
                />
                :
                <Typography
                  sx={{
                    textTransform: "none",
                    textAlign: "left",
                    font: "normal normal 700 14px/18px Lato",
                    letterSpacing: "0px",
                    color: "#100C08",
                    opacity: "1",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    width: "100%",  
                  }}
                >{tabTitle}</Typography>
              )
            }
          </Grid>
          {classType === "Chart" && showClearIcon && (
            <Grid
              item
              sx={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                marginLeft: "auto",
              }}
            >
              <ClearIcon
                onClick={handleCloseChart}
                sx={{ color: "red", height: "19px", width: "19px" }}
              />
            </Grid>
          )}
        </Grid>
      </Grid>
      {classType === "Dashboard" ? <Grid item sx={verticalLine}></Grid> : null}
    </>

  );
}
